import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";

import { AgencyService, IGetAgency, IGetOrganization } from "../../../../../services/agency.service";
import config from "../../../../../common/config";
import { ApplicationEnum, ApplicationNameEnum } from "../../../../../enums/ApplicationEnum";
import { PermissionManager } from "../../../../../common/utilities/permission-manager";
import { ParentPermissionEnum } from "../../../../../enums/ParentPermissionEnum";
import { PermissionActionEnum } from "../../../../../enums/PermissionActionEnum";
import { BranchesService } from "../../../../../services/branches-service";
import { IBranchResponse } from "../../../../../resources-vue/vue-interfaces/i-branch";
import { IGetTeamsLeanQuery } from "../../../../../resources-vue/vue-interfaces/i-team";
import { TeamsService } from "../../../../../services/teams.service";
import { ITypeaheadOptions } from "../../../../../resources-vue/vue-interfaces/i-typeahead";
import { HopeFilters } from "../../../../../enums/HopeFiltersEnum";
import { IPageCallbackResult } from "../../../../../resources-vue/vue-interfaces/i-page-container";
import { HuvSfvTaskStatus } from "../../../../../enums/HuvSfvTaskStatusEnum";
import { ReportService } from "../../../../../services/report-service";
import { ToastrService } from "../../../../../services/toastr.service";
import { PAGE_FAIL_RESPONSE } from "../../../../CentralIntake/Inquiry/CentralInquiry";
import { IMultiSelectDropDownOption } from "../../../../../resources-vue/vue-elements/MultiSelect/MultiSelect";
import { DownloadService } from "../../../../../services/download.service";
import { TaskService } from "../../../../../services/task.service";

import Pagination from "../../../../../resources-vue/vue-elements/Pagination/Pagination.vue";
import SortableTh from "../../../../../resources-vue/vue-custom-elements/SortableTh/SortableTh.vue";
import ErrorMessageHandler from "../../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";
import MultiSelectFilter from "../../../../../resources-vue/vue-elements/MultiSelectFilter/MultiSelectFilter.vue";
import PageLayout from "../../../../../resources-vue/vue-custom-elements/PageLayout/PageLayout.vue";
import HuvSfvStatusReportHosRow from "./HuvSfvStatusReportHosRow/HuvSfvStatusReportHosRow.vue";
import MultiSelect from "../../../../../resources-vue/vue-elements/MultiSelect/MultiSelect.vue";

export default defineComponent({
    components: {
        MultiSelect,
        MultiSelectFilter,
        Pagination,
        SortableTh,
        ErrorMessageHandler,
        PageLayout,
        HuvSfvStatusReportHosRow
    },
    data(vm) {
        return {
            _taskService: null as TaskService,
            _downloadService: null as DownloadService,
            _toastrService: null as ToastrService,
            _reportService: null as ReportService,
            _teamService: null as TeamsService,
            _branchService: null as BranchesService,
            _permissionManager: null as PermissionManager,
            _agencyService: null as AgencyService,
            selectedAgency: "" as string,
            organizations: [] as IGetOrganization[],
            organizationName: "",
            agencyList: [] as IGetAgency[],
            agencyOptions: [] as any,
            branchMultiSelectOptions: {} as IMultiSelectDropDownOption,
            selectedBranches: [] as string[],
            branches: [] as IBranchResponse[],
            branchList: [] as IBranchResponse[],
            selectedTeams: [] as ITypeaheadOptions[],
            hopeFilters: HopeFilters,
            taskStatuses: HuvSfvTaskStatus,
            selectedHopeFilter: [],
            selectedTaskStatus: [],
            selectedTask: [],
            isLoading: false as boolean,
            isError: false as boolean,
            page: null,
            pageSize: 10,
            columns: 12,
            sortBy: "branch",
            sortOrder: "asc",
            huvSfvStatusPagination: null,
            disciplineTasks: [],
            application: ApplicationEnum.AxxessHospiceFE
        };
    },
    async created() {
        this._taskService = Container.instance.get(TaskService);
        this._branchService = Container.instance.get(BranchesService);
        this._agencyService = Container.instance.get(AgencyService);
        this._permissionManager = Container.instance.get(PermissionManager);
        this._teamService = Container.instance.get(TeamsService);
        this._reportService = Container.instance.get(ReportService);
        this._toastrService = Container.instance.get(ToastrService);
        this._downloadService = Container.instance.get(DownloadService);
        this.huvSfvStatusPagination = this.$refs.huvSfvStatusPagination as typeof Pagination;
        this.branches = await this._branchService.getAllBranches();
        this.branchList = this.branches.filter((branch) => branch.application == ApplicationEnum.AxxessHospiceFE);
    },

    async mounted() {
        this.huvSfvStatusPagination = this.$refs.huvSfvStatusPagination as typeof Pagination;
        this.organizations = await this._agencyService.getOrganizations();
        this.organizationName = window.localStorage.getItem(config.organizationName);
        this.agencyList = this.organizations.find(
            (organization: { name: string }) => organization.name === this.organizationName
        ).agencies;
        this.agencyList = this.agencyList.map((agency) => {
            let agencyAndApplicationIds = agency.id.split("_");
            let application = parseInt(agencyAndApplicationIds[1], 10);
            if (application == 256) {
                application = ApplicationEnum.AxxessHospice;
            }
            return {
                ...agency,
                application: application
            };
        });
        await this.setAgencyMultiSelect();
        await this.setBranchMultiSelect();
        this.pageReset();
    },
    computed: {
        hasData() {
            return this.page?.Items.length > 0;
        },
        loadingCount() {
            return this.page?.Items.length > 0 ? this.page.Items.length : config.pageSize;
        }
    },

    watch: {
        selectedAgency() {
            this.setBranchMultiSelect();
            this.pageReset();
        }
    },

    methods: {
        async setAgencyMultiSelect() {
            try {
                this.agencyOptions = [];
                if (!this.agencyList || this.agencyList?.length === 0) {
                    return;
                }
                let application = ApplicationEnum.AxxessHospice;
                let allowedProducts = [application];
                const schedulerViewPermissions = this._permissionManager.getPermmission(
                    ParentPermissionEnum.scheduler,
                    PermissionActionEnum.canView
                );
                let schedulerAgencies = schedulerViewPermissions
                    .filter((item: any) => {
                        if (!item) {
                            return false;
                        }
                        let currentapplication = item.application;
                        if (currentapplication === ApplicationEnum.AxxessHospiceFE) {
                            currentapplication = ApplicationEnum.AxxessHospice;
                        }
                        return allowedProducts.includes(currentapplication);
                    })
                    .map((x: any) => x.agencyId);
                let filterableProducts = this.agencyList.filter((agency) => {
                    let isAllowed = allowedProducts.includes(agency.application);
                    let agencyId = agency.id?.split("_")[0];
                    return isAllowed && schedulerAgencies.includes(agencyId);
                });
                filterableProducts?.forEach((agency, index) => {
                    this.agencyOptions.push({
                        name: agency.name,
                        value: agency.id
                    });
                });
                this.selectedAgency = this.agencyOptions[0].value;
                // uncomment once BE accept multiple agencies
                // Object.values(this.agencyMultiSelectOptions).forEach((agency: any) => {
                //     let values = agency.map((item: any) => item.value);
                //     this.selectedAgencies.push(...values);
                // });
            } catch (e) {
                console.warn(e);
            }
        },
        async setBranchMultiSelect() {
            try {
                this.branchMultiSelectOptions = {};
                this.selectedBranches = [];
                if (!this.branchList || this.branchList?.length === 0) {
                    return;
                }
                let allowedProducts = [ApplicationEnum.AxxessHospiceFE];
                const schedulerViewPermissions = this._permissionManager.getPermmission(
                    ParentPermissionEnum.scheduler,
                    PermissionActionEnum.canView
                );

                // const selectedAgencies = this.selectedAgencies.map((agency: any) => agency.split("_")[0]);

                let schedulerAgencies = schedulerViewPermissions
                    .filter((item: any) => {
                        if (!item) {
                            return false;
                        }
                        let application = item.application;
                        return (
                            allowedProducts.includes(application) && this.selectedAgency.split("_")[0] === item.agencyId
                        );
                    })
                    .map((x: any) => x.agencyId);
                let filterableProducts = this.branchList.filter((branch) => {
                    let isAllowed = allowedProducts.includes(branch.application);
                    return (
                        isAllowed &&
                        schedulerAgencies.includes(branch.accountId) &&
                        this.selectedAgency.split("_")[2] === branch.providerId
                    );
                });
                filterableProducts?.forEach((branch) => {
                    let application = branch.application;
                    if (application === ApplicationEnum.AxxessHospiceFE) {
                        application = ApplicationEnum.AxxessHospice;
                    }
                    let appName = ApplicationNameEnum[application];

                    if (!this.branchMultiSelectOptions[appName]) {
                        this.branchMultiSelectOptions[appName] = [];
                    }

                    this.branchMultiSelectOptions[appName].push({
                        displayText: branch.name,
                        value: branch.id
                    });
                });

                Object.values(this.branchMultiSelectOptions).forEach((branch: any) => {
                    let values = branch.map((item: any) => item.value);
                    this.selectedBranches.push(...values);
                });
            } catch (e) {
                console.warn(e);
            }
        },
        updateBranches(branches: any) {
            this.selectedBranches = [];
            this.selectedBranches.push(...branches);
            this.pageReset();
        },
        async getTeamsList(filter: string) {
            const payload = {
                application: ApplicationEnum.AxxessHospiceFE,
                accountId: this.selectedAgency.split("_")[0],
                locationIds: this.selectedBranches
            } as IGetTeamsLeanQuery;
            const response = await this._teamService.getTeamsLean(payload);
            const uniqueOptions = new Map();
            response.forEach((team: any) => {
                if (!uniqueOptions.has(team.name)) {
                    uniqueOptions.set(team.name, {
                        name: team.name,
                        value: team.id
                    });
                }
            });
            const result = Array.from(uniqueOptions.values()).filter(
                (x) => !filter || x.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase())
            );
            return result;
        },
        selectedTeamsUpdated(options: ITypeaheadOptions[]) {
            this.selectedTeams = options;
            this.pageReset();
        },
        getHuvSvfStatusOptions() {
            let filters = [];
            this.hopeFilters.enumWithDescriptions.forEach((filter) => {
                filters.push(filter);
            });
            return filters;
        },
        getHuvSvfTaskStatusOptions() {
            let filters = [];
            this.taskStatuses.enumWithDescriptions.forEach((filter) => {
                filters.push(filter);
            });
            return filters;
        },
        selectedHopeFilterUpdates(options: ITypeaheadOptions[]) {
            this.selectedHopeFilter = options;
            this.pageReset();
        },
        selectedTaskStatusFilterUpdates(options: ITypeaheadOptions[]) {
            this.selectedTaskStatus = options;
            this.pageReset();
        },

        selectedTaskFilterUpdates(options: ITypeaheadOptions[]) {
            this.selectedTask = options;
            this.pageReset();
        },
        async pageChangedCallback(pageNumber: number, pageSize: number): Promise<IPageCallbackResult> {
            if (!this.selectedAgency) {
                this._toastrService.error({
                    title: `Error`,
                    message: `Select at least one agency and branch to proceed.`
                });
                return PAGE_FAIL_RESPONSE;
            }
            try {
                this.isLoading = true;
                this.isError = false;
                const payload = {
                    Application: ApplicationEnum.AxxessHospiceFE,
                    AccountId: this.selectedAgency.split("_")[0],
                    UserId: "",
                    LocationIds: this.selectedBranches,
                    Page: pageNumber,
                    PageLength: pageSize,
                    SortBy: this.sortBy,
                    Order: this.sortOrder,
                    TeamIds: this.selectedTeams.map((filter) => filter.value),
                    TaskStatuses: this.selectedTaskStatus.map((filter) => filter.value),
                    HopeTypeFilters: this.selectedHopeFilter.map((filter) => filter.value),
                    DisciplineTaskIds: this.selectedTask.map((filter) => filter.value)
                };
                const response = (await this._reportService.getHuvSfvStatusList(payload)) as any;
                this.page = response;
                return {
                    totalPageCount: response.PageCount,
                    success: response.ItemCount > 0,
                    totalCount: response.ItemCount
                };
            } catch (e) {
                this.isError = true;
                return PAGE_FAIL_RESPONSE;
            } finally {
                this.isLoading = false;
            }
        },
        updatePageSizeChanged(value: number) {
            this.pageSize = value;
        },
        sortByUpdated(value: string) {
            if (value != this.sortBy) {
                this.sortBy = value;
                this.pageReset();
            }
        },

        sortOrderUpdated(value: string) {
            if (value != this.sortOrder) {
                this.sortOrder = value;
                this.pageReset();
            }
        },

        pageReset() {
            this.isError = false;
            this.huvSfvStatusPagination?.reset();
        },

        async exportStatusList() {
            const payload = {
                AccountId: this.selectedAgency.split("_")[0],
                UserId: "",
                TeamIds: this.selectedTeams.map((filter: any) => filter.value),
                LocationIds: this.selectedBranches,
                TaskStatuses: this.selectedTaskStatus.map((filter) => filter.value),
                HopeTypeFilters: this.selectedHopeFilter.map((filter) => filter.value),
                SortBy: "taskStatus",
                Order: this.sortOrder,
                Application: this.application,
                DisciplineTaskIds: this.selectedTask.map((filter) => filter.value)
            };
            try {
                const response = (await this._reportService.exportHuvList(payload)) as any;
                this._downloadService.downloadFile(response, response.type);
            } catch (err) {
                this._toastrService.error({
                    title: `Error`,
                    message: "Failed to download File ! Please Try Again!!"
                });
            }
        },
        async getTaskStatusLean() {
            const payload = {
                AccountId: this.selectedAgency.split("_")[0],
                Application: this.application,
                LineOfService: 1,
                AreHuvTasksNonInitial: true
            };
            const response = (await this._taskService.getCustomTask(payload)) as any;
            this.disciplineTasks = response;
            let filters = [];
            this.disciplineTasks.forEach((task: any) => {
                filters.push({
                    name: task.MetaName,
                    value: task.MetaId
                });
            });
            return filters;
        }
    }
});
